<float-widget-header
    [widget]="cell.activeWidget"
    float-cell-widget-draggable
    float-cell-widget-removable>
</float-widget-header>

<div class="float-widget_body">
    <widget-body-renderer [widget]="cell.activeWidget"></widget-body-renderer>
</div>
